import * as React from 'react';
import { Button, Form, Space } from '@duxton-web/ui';

import AppVersionFieldset from './AppVersionFieldset';
import { isValidAppVersion } from './appVersionUtils';

import './AppVersionPrompt.css';

const InputGroup = Space.Compact;

interface AppVersionPromptProps {
  initialValue?: string;
  onSubmit: (value: string) => void;
  onCancel: () => void;
}

interface AppVersionPromptState {
  appVersion: string;
  hasError: boolean;
}

export class AppVersionPrompt extends React.Component<
  AppVersionPromptProps,
  AppVersionPromptState
> {
  containerElement: HTMLSpanElement;

  constructor(props: AppVersionPromptProps) {
    super(props);
    this.state = {
      appVersion: props.initialValue || '',
      hasError: false,
    };
  }

  handleAppVersionChange = (appVersion) => {
    this.setState({ appVersion, hasError: false });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleSubmit = (e) => {
    // e.preventDefault();
    const { onSubmit } = this.props;
    const { appVersion } = this.state;
    const hasError = !isValidAppVersion(appVersion);
    if (hasError) {
      this.setState({ hasError });
    } else {
      onSubmit(appVersion);
    }
  };

  setContainerElement = (element: HTMLSpanElement) => {
    this.containerElement = element;
  };

  getPopupContainer = () => {
    return this.containerElement;
  };

  render() {
    const { appVersion, hasError } = this.state;
    const { onCancel } = this.props;

    return (
      <span
        className="app-verion-prompt__container"
        ref={this.setContainerElement}
      >
        <Form onFinish={this.handleSubmit}>
          <div className={hasError ? 'has-error' : ''}>
            <InputGroup>
              <AppVersionFieldset
                value={appVersion}
                onChange={this.handleAppVersionChange}
                getPopupContainer={this.getPopupContainer}
              />
            </InputGroup>
            <span className="app-verion-prompt__error">
              Invalid app version!
            </span>
            <div className="app-verion-prompt__actions">
              <Button
                size="small"
                onClick={onCancel}
                className="app-verion-prompt__cancel"
              >
                Cancel
              </Button>
              <Button size="small" type="primary" htmlType="submit">
                Apply
              </Button>
            </div>
          </div>
        </Form>
      </span>
    );
  }
}

export default AppVersionPrompt;
